module.exports = __webpack_public_path__ + "/login_ui/img/sn-f895f4908bff14661540b3922ed9435d.svg";